import { render } from "./ChangedProductRow.vue?vue&type=template&id=1dabbe9b"
import script from "./ChangedProductRow.vue?vue&type=script&lang=js"
export * from "./ChangedProductRow.vue?vue&type=script&lang=js"

import "./ChangedProductRow.vue?vue&type=style&index=0&id=1dabbe9b&lang=less"

import exportComponent from "/builds/sun-chemical/color-materials/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__